import React, { Component } from 'react';
import { matchPath } from 'react-router';
import Helmet from 'react-helmet';

import './Discover.css';
import AuthService from './AuthService';
import NavBar from './Navbar';
import UserNavbar from './UserNavbar';
import Product from './Product';
import constants from '../config';
import AuthModalContext from '../contexts/AuthModalContext';


const Auth = new AuthService();

class Discover extends Component {
  static contextType = AuthModalContext;
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      category: '',
      showItems: 30,
      link: '',
    };
    this.toLogin = this.toLogin.bind(this);
    this.toSignUp = this.toSignUp.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    this.toLanding = this.toLanding.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);

    this.hideCats = this.hideCats.bind(this);

    this.latest = this.latest.bind(this);
    this.navbar = this.navbar.bind(this);
    this.profile = this.profile.bind(this);
    this.discover = this.discover.bind(this);
    this.dictionary = this.dictionary.bind(this);
    this.handlePost = this.handlePost.bind(this);
    this.handleHome = this.handleHome.bind(this);
    this.handleSelfProfile = this.handleSelfProfile.bind(this);
    this.handleNotifications = this.handleNotifications.bind(this);
  }
  componentWillMount() {

  }
  componentDidMount() {
    this.navbar();
    // this.setState({
    //   content: <PopularCategory />
    // });
    const match = matchPath(this.props.history.location.pathname, {
      path: '/discover/:category',
      exact: false,
      strict: false,
    });
    const category = match.params.category;
    this.discover(category);
    // category === 'popular'
    // localhost:3000/discover/popular
  }

  componentWillReceiveProps(nextProps) {

    const pastMatch = matchPath(this.props.history.location.pathname, {
      path: '/discover/:category',
      exact: false,
      strict: false,
    });
    const currentMatch = matchPath(nextProps.history.location.pathname, {
      path: '/discover/:category',
      exact: false,
      strict: false,
    });

    if (currentMatch !== pastMatch) {
      const currentCategory = currentMatch.params.category;
      this.discover(currentCategory);
    }
  }

  navbar() {
    if (Auth.getToken()) {
      this.setState({
        navbar: <UserNavbar handleSearch={(search) => this.handleSearch(search)} user={Auth.getProfile()} handleSelfProfile={this.handleSelfProfile} handlePost={this.handlePost} handleHome={this.handleHome} handleNotifications={this.handleNotifications}/>
      });
    } else {
      this.setState({
        navbar: <NavBar handleSearch={(search) => this.handleSearch(search)} signUp={this.toSignUp} login={this.toLogin} />,
      });
    }
  }
  // Guest Navbar
  handleSearch(search) {
    this.setState({
      query: search,
    }, () => {
      this.props.history.push(`/search/${this.state.query}`);
    });
  }

  toLogin() {
    this.context.openAuthModal('login');
  }

  toLanding() {
    this.props.history.replace('/');
  }

  toSignUp() {
    this.context.openAuthModal('signup');
  }

  // USER NAVBAR
  handlePost() {
    this.props.history.push('/sell');
  }
  handleHome() {
    this.props.history.push('/');
  }
  handleSelfProfile() {
    const user = Auth.getProfile();
    this.props.history.push(`/shop/${user.username}`);
  }
  handleNotifications() {
    this.props.history.push('/notifications');
  }
  dictionary(category) {
    if (category === 'singles') {
      this.setState({ category: 'Card Singles' });
    }
    if (category === 'decks') {
      this.setState({ category: 'Decks' });
    }
    if (category === 'boosters') {
      this.setState({ category: 'Booster Packs' });
    }
    if (category === 'collection') {
      this.setState({ category: 'Collection' });
    }
    if (category === 'lots') {
      this.setState({ category: 'Card Lots' });
    }
    if (category === 'proxies') {
      this.setState({ category: 'Proxies' });
    }
    if (category === 'sleeves') {
      this.setState({ category: 'Card Sleeves' });
    }
    if (category === 'deckBox') {
      this.setState({ category: 'Deck Boxes' });
    }
    if (category === 'playmats') {
      this.setState({ category: 'Playmats' });
    }
    if (category === 'figures') {
      this.setState({ category: 'Figures' });
    }
    if (category === 'videoGames') {
      this.setState({ category: 'Video Games' });
    }
    if (category === 'rulings') {
      this.setState({ category: 'Rulings' });
    }
    if (category === 'deckBuild') {
      this.setState({ category: 'Deck Build' });
    }
    if (category === 'rogueList') {
      this.setState({ category: 'Rogue List' });
    }
    if (category === 'nm') {
      this.setState({ category: 'Near Mint' });
    }
    if (category === 'nmf') {
      this.setState({ category: 'Near Mint Foil' });
    }
    if (category === 'lp') {
      this.setState({ category: 'Lightly Played' });
    }
    if (category === 'lpf') {
      this.setState({ category: 'Lightly Played Foil' });
    }
    if (category === 'mp') {
      this.setState({ category: 'Moderately Played' });
    }
    if (category === 'mpf') {
      this.setState({ category: 'Moderately Played Foil' });
    }
    if (category === 'hp') {
      this.setState({ category: 'Heavily Played' });
    }
    if (category === 'damaged') {
      this.setState({ category: 'Damaged' });
    }
    if (category === 'other') {
      this.setState({ category: 'Other' });
    }
  }
  discover(category) {
    if (Auth.getToken()) {
      Auth.fetch(`${constants.DOMAIN}/api/v1/func/category/?search=${category}`, {
        mode: 'cors',
        method: 'GET',
      }).then(res => {
        this.profile();
        this.setState({
          posts: res.posts,
          link: category,
        }, () => {
          this.dictionary(category);
        });
      })
        .catch(err => {
          console.log(err);
        });
    } else {
      Auth.fetch(`${constants.DOMAIN}/api/v1/guest/category/?search=${category}`, {
        mode:'cors',
        method:'GET',
      }).then( res => {
        this.setState({
          posts: res.posts,
          link: category,
        }, () => {
          this.dictionary(category);
        });
      })
        .catch(err => {
          console.log(err);
        });
    }
  }

  latest() {
    Auth.fetch(`${constants.DOMAIN}/api/v1/guest/post`, {
      mode: 'cors',
      method: 'GET',
    }).then(res => {
      // console.log('latest', res);
      this.setState({
        posts: res.posts,
      });
    })
      .catch(err => {
        console.log(err);
      });
  }
  handleShowMore() {
    this.setState({
      showItems:
        this.state.showItems >= this.state.posts.length ?
          this.state.showItems : this.state.showItems + 25,
    });
  }
  profile() {
    if (Auth.getToken()) {
      const user = Auth.getProfile();
      Auth.fetch(`${constants.DOMAIN}/api/v1/users/${user._id}`, {
        mode: 'cors',
        method: 'GET',
      }).then(res => {
        this.setState({
          sortedProfile: res.sortedProfile,
        });
      })
        .catch(err => {
          console.log(err);
        });
    } else {
      return;
    }

  }
  hideCats() {
    const content = document.getElementsByClassName('.popup-overlay');
    content.style.display = 'none';
  }
  render() {
    const posts = this.state.posts.slice(0, this.state.showItems).map(post =>
      (<Product
        _id={post._id}// Every unique post haa an _id
        key={post._id}
        post_id={post.post_id}
        profile={(userId) => this.profile(userId)}
        price={post.price}
        sortedProfile={this.state.sortedProfile}
        shippingCost={post.shippingCost}
        name={post.user.name}
        userName={post.user.userName}
        sellerId={post.user._id}
        sellerRating={post.user.rating}
        marketer={post.marketer}
        picture={post.user.picture}
        sold={post.sold}
        category={post.category}
        title={post.title}
        image={post.images[0]}
        favoriteCount={post.favoriteCount}
        shareCount={post.shareCount}
        comments={post.comments}
        favorite={post.favorite}
        share={post.share}
      />));
    return (
      <div className="Categories">
        <Helmet>
          <title>Discover {this.state.category} products | Primal Marketplace</title>
          <meta name="description" content={`Discover ${this.state.category} products`} />
          <meta property="og:title"       content={`Discover ${this.state.category} products | Primal Marketplace`} />
          <meta property="og:description" content={`Discover ${this.state.category} products`} />
        </Helmet>
        {this.state.navbar}
        <div className="col-12 notifications-heading">
          <h3>{this.state.category}</h3>
        </div>
        <div className="col-md-3 self-profile-ghost"></div>
        <div className="col-md-5 col-xs-12 productContainer">
          {posts}
          <a href="#more/" style={{ width: '100%', height: '40px', backgroundColor: '#c9a84c', color: 'white', fontSize: '18px', fontWeight: 'bold', marginBottom: '20px' }} onClick={this.handleShowMore} className="btn">Show more</a>
        </div>
      </div>
    );
  }
}

export default Discover;
